import React from "react";

export default function ProductCard({ rec }) {
    return (
        <div className="card-product">
            <a className="card-title" href={rec.Url} dangerouslySetInnerHTML={{ __html: rec.Name }} />
            <div className="card-details">
                <div className="card-price" dangerouslySetInnerHTML={{ __html: rec.Price }}></div>
                <div className="card-rating">
                    <div className="quizReviewStars styleReviews jsHide" data-bv-show="inline_rating" data-bv-product-id={rec.Id}></div>
                </div>
            </div>
            <a href={rec.Url} className="card-image" aria-label={`View ${rec.Name}`}>
                <picture>
                    <source width="302" height="302" media="(min-width: 768px)" srcSet={`${rec.WebImage}?w=240 1x, ${rec.WebImage}?w=480 2x`} />
                    <source width="154" height="154" srcSet={`${rec.WebImage}?w=231 1x, ${rec.WebImage}?w=462 2x`} />
                    <img width="154" height="154" src={`${rec.WebImage}?w=195`} alt={rec.Name || "Product image"} loading="lazy" />
                </picture>
            </a>
        </div>
    );
}
